/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useReducer, useEffect } from 'react';
import defer from 'hs-promise-utils/defer';
import { RequestStatus } from '../../../api/constants';
const getInitialState = () => {
  return {
    requestStatus: RequestStatus.UNINITIALIZED,
    properties: []
  };
};
const fetchPropertiesReducer = (state, {
  requestStatus,
  properties
}) => {
  switch (requestStatus) {
    case RequestStatus.PENDING:
      return Object.assign({}, state, {
        requestStatus
      });
    case RequestStatus.SUCCEEDED:
      return {
        requestStatus,
        properties
      };
    case RequestStatus.FAILED:
      return Object.assign({}, state, {
        requestStatus
      });
    default:
      return state;
  }
};
export const useProperties = fetchProperties => {
  // useReducer allows us to guarantee requestStatus is set to SUCCEEDED
  // at the exact same time as properties is set to the API response;
  // were we to simply use two useState hooks, there would be an interstitial
  // tick between the first useState call and the second, which would mean that
  // our requestStatus state is desynced from the actual request value itself
  const initialState = getInitialState();
  const [{
    requestStatus,
    properties
  }, dispatch] = useReducer(fetchPropertiesReducer, initialState);
  useEffect(() => {
    const deferredRequest = defer();
    dispatch({
      requestStatus: RequestStatus.PENDING
    });
    fetchProperties().then(categories => {
      const relevantCategories = categories.filter(category => category !== null);
      return relevantCategories;
    }).then(deferredRequest.resolve);
    deferredRequest.promise.then(fetchedProperties => {
      dispatch({
        requestStatus: RequestStatus.SUCCEEDED,
        properties: fetchedProperties
      });
    }).catch(err => {
      dispatch({
        requestStatus: RequestStatus.FAILED
      });
      console.warn(err);
    });
    return () => {
      deferredRequest.reject('[rich-text-lib][personalization][fetchProperties] component unmounting abort state update');
    };
  }, [fetchProperties]);
  return [properties, requestStatus];
};